import { Injectable } from '@angular/core';
import { GeneralConstants } from '../constants/general.constants';
import { RecipientModel } from '../models/recipient.model';
import { BaseResponseClass } from '../models/response/base-response-class.model';
import { BaseResponse } from '../models/response/base.response';
import { RestService } from './rest.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class RecipientsService {
  constructor(private restService: RestService, private notificationService: NotificationService) {}

  public getRecipients = async (): Promise<RecipientModel[]> => {
    const response: BaseResponseClass = await this.restService.get(GeneralConstants.getRecipientRoute, {});
    try {
      return response.listOfResults.listOfResult.map(
        (recipient) =>
          new RecipientModel(recipient.id, recipient.tipoPersona, recipient.nombre, recipient.cvuCbu, recipient.alias)
      );
    } catch (error) {
      this.notificationService.mgsView({
        error: null,
        messenger: error.message,
        title: 'Agenda',
        type: 3,
        configNotification: null
      });
    }
  };

  public deleteRecipient = async (recipient: RecipientModel) => {
    try {
      const response: BaseResponseClass = await this.restService.post(GeneralConstants.deleteRecipientRoute, recipient);
      this.notificationService.mgsView({
        error: null,
        messenger: response.message,
        title: 'Agenda',
        type: 1,
        configNotification: null
      });
    } catch (error) {
      this.notificationService.mgsView({
        error: null,
        messenger: error.message,
        title: 'Agenda',
        type: 3,
        configNotification: null
      });
    }
  };

  public saveRecipient = async (recipient: RecipientModel) => {
    try {
      const response = await this.restService.post(GeneralConstants.saveRecipientRoute, recipient);
      this.notificationService.mgsView({
        error: null,
        messenger: response.message,
        title: 'Agenda',
        type: 1,
        configNotification: null
      });
    } catch (error) {
      this.notificationService.mgsView({
        error: null,
        messenger: error.message,
        title: 'Agenda',
        type: 2,
        configNotification: null
      });
    }
  };
}
